import { whatsapp } from './assets';
import { logAnalyticsEvent } from '../../GoogeAnalytics';

const Whatsapp = () => {
  return (
    <a
      href="https://wa.me/+919885663163"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      onClick={() => {
        logAnalyticsEvent('button_click', {
          button_name: 'whatsapp_chat',
          button_type: 'social',
          page_path: window.location.pathname,
        });
      }}
    >
      <img
        width={25}
        height={25}
        src={whatsapp}
        alt="WhatsApp"
      />
    </a>
  );
};

export default Whatsapp;
